export default "__VITE_ASSET__BvMOn6BQ__"